(function () {
  const init = (section) => {
    const slides = Array.from(section.querySelectorAll('[data-std-slide]'));
    const prevLabel = section.querySelector('[data-std-prev-label]');
    const nextLabel = section.querySelector('[data-std-next-label]');
    const prevButtons = Array.from(section.querySelectorAll('[data-std-prev]'));
    const nextButtons = Array.from(section.querySelectorAll('[data-std-next]'));
    const dots = Array.from(section.querySelectorAll('[data-std-dot]'));
    if (slides.length === 0) return;

    const wrap = section.dataset.wrap === 'true';
    const count = slides.length;
    let current = 0;

    const getLabel = (index) => {
      const slide = slides[index];
      return slide?.dataset.label || '';
    };

    const update = () => {
      slides.forEach((slide, i) => {
        const active = i === current;
        slide.classList.toggle('is-active', active);
        if (active) {
          slide.removeAttribute('aria-hidden');
        } else {
          slide.setAttribute('aria-hidden', 'true');
        }
      });

      dots.forEach((dot, i) => {
        const active = i === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      const hasPrev = wrap ? count > 1 : current > 0;
      const hasNext = wrap ? count > 1 : current < count - 1;

      const prevIdx = wrap ? (current - 1 + count) % count : current - 1;
      const nextIdx = wrap ? (current + 1) % count : current + 1;

      if (prevLabel) {
        prevLabel.textContent = hasPrev ? getLabel(prevIdx) : '';
      }
      if (nextLabel) {
        nextLabel.textContent = hasNext ? getLabel(nextIdx) : '';
      }

      prevButtons.forEach((btn) => {
        if (!hasPrev) {
          btn.setAttribute('disabled', '');
          btn.setAttribute('aria-disabled', 'true');
        } else {
          btn.removeAttribute('disabled');
          btn.removeAttribute('aria-disabled');
        }
      });
      nextButtons.forEach((btn) => {
        if (!hasNext) {
          btn.setAttribute('disabled', '');
          btn.setAttribute('aria-disabled', 'true');
        } else {
          btn.removeAttribute('disabled');
          btn.removeAttribute('aria-disabled');
        }
      });
    };

    const go = (index) => {
      if (wrap) {
        current = ((index % count) + count) % count;
      } else {
        current = Math.max(0, Math.min(count - 1, index));
      }
      update();
    };

    prevButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (btn.hasAttribute('disabled')) return;
        go(current - 1);
      });
    });

    nextButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (btn.hasAttribute('disabled')) return;
        go(current + 1);
      });
    });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.index || '0', 10);
        go(index);
      });
    });

    const stage = section.querySelector('[data-std-stage]');
    stage?.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        go(current + 1);
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        go(current - 1);
      }
    });

    // Touch swipe
    let touchStartX = null;
    stage?.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });
    stage?.addEventListener('touchend', (e) => {
      if (touchStartX == null) return;
      const delta = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(delta) > 40) {
        go(delta < 0 ? current + 1 : current - 1);
      }
      touchStartX = null;
    }, { passive: true });

    update();
  };

  const boot = () => {
    document.querySelectorAll('[data-std-section]').forEach((section) => {
      if (section.__stdInit) return;
      section.__stdInit = true;
      init(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-std-section]');
    if (section && !section.__stdInit) {
      section.__stdInit = true;
      init(section);
    }
  });
})();
